/**
 * Clean url without query params and hashtags.
 *
 * @param {string} url the URL string.
 * @return {string} the clean URL.
 */
function createCleanURL( url ) {
	let cleanUrl = url.split( '#' );

	if ( cleanUrl.length ) {
		cleanUrl = cleanUrl[0];
	}

	cleanUrl = cleanUrl.split( '?' );

	if ( cleanUrl.length ) {
		cleanUrl = cleanUrl[0];
	}

	return cleanUrl;
}

/**
 * Cancel form. Adds a query params to open a modal on the next page.
 */
function cancelForm() {
	const cancelButton = document.querySelector( '.confirm-cancel-button' );
	if ( !cancelButton ) {
		return;
	}
	cancelButton.addEventListener( 'click', function cancelForm() {
		// Reloads page clearing data.
		const clearURL = createCleanURL( window.location.href );
		window.location = `${clearURL}?prompt=form-deleted`;
	});
}

/**
 * Adds the cancel modals.
 */
export function cancelFormModal() {
	cancelForm();
}
